const pageNameKey = "tsidContainer";

export const tsidContainerEn = {
  [pageNameKey]: {
    tsidLabel: "TSID",
    tsidTooltip: "Copy TSID to clipboard",
    tsidLoadingMessage: "Loading...",
    tsidNotAvailableMessage: "TSID not available",
    tsidSnackbarSuccess: "TSID copied to clipboard",
    tsidErrorMessage: "It was not possible to copy the TSID to the clipboard",
  },
};

export const tsidContainerPtBr = {
  [pageNameKey]: {
    tsidLabel: "TSID",
    tsidTooltip: "Copiar TSID para a área de transferência",
    tsidLoadingMessage: "Carregando...",
    tsidNotAvailableMessage: "TSID indisponível",
    tsidSnackbarSuccess: "TSID copiado para a área de transferência",
    tsidErrorMessage:
      "Não foi possível copiar o TSID para a área de transferência",
  },
};

export const tsidContainerDe = {
  [pageNameKey]: {
    tsidLabel: "TSID",
    tsidTooltip: "TSID in die Zwischenablage kopieren",
    tsidLoadingMessage: "Lade...",
    tsidNotAvailableMessage: "TSID nicht verfügbar",
    tsidSnackbarSuccess: "TSID in die Zwischenablage kopiert",
    tsidErrorMessage:
      "Die TSID konnte nicht in die Zwischenablage kopiert werden",
  },
};

export const tsidContainerZhHans = {
  [pageNameKey]: {
    tsidLabel: "TSID",
    tsidTooltip: "复制TSID到剪贴板",
    tsidLoadingMessage: "加载中...",
    tsidNotAvailableMessage: "TSID不可用",
    tsidSnackbarSuccess: "TSID已复制到剪贴板",
    tsidErrorMessage: "无法将TSID复制到剪贴板",
  },
};

export const tsidContainerIt = {
  [pageNameKey]: {
    tsidLabel: "TSID",
    tsidTooltip: "Copia TSID negli appunti",
    tsidLoadingMessage: "Caricamento...",
    tsidNotAvailableMessage: "TSID non disponibile",
    tsidSnackbarSuccess: "TSID copiato negli appunti",
    tsidErrorMessage: "Non è stato possibile copiare il TSID negli Appunti",
  },
};

export const tsidContainerEs = {
  [pageNameKey]: {
    tsidLabel: "TSID",
    tsidTooltip: "Copiar TSID al portapapeles",
    tsidLoadingMessage: "Cargando...",
    tsidNotAvailableMessage: "TSID no disponible",
    tsidSnackbarSuccess: "TSID copiado al portapapeles",
    tsidErrorMessage: "No fue posible copiar el TSID al portapapeles",
  },
};

export const tsidContainerNl = {
  [pageNameKey]: {
    tsidErrorMessage: "TSID kon niet naar het klembord worden gekopieerd",
    tsidLabel: "TSID",
    tsidLoadingMessage: "Laden...",
    tsidNotAvailableMessage: "TSID niet beschikbaar",
    tsidSnackbarSuccess: "TSID naar klembord gekopieerd",
    tsidTooltip: "TSID kopiëren naar klembord",
  },
};

export const tsidContainerTr = {
  [pageNameKey]: {
    tsidErrorMessage: "TSID'yi panoya kopyalamak mümkün olmadı",
    tsidLabel: "TSID",
    tsidLoadingMessage: "Yükleniyor...",
    tsidNotAvailableMessage: "TSID mevcut değil",
    tsidSnackbarSuccess: "TSID panoya kopyalandı",
    tsidTooltip: "TSID'yi panoya kopyala",
  },
};
